import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { TrainTypesEntityGrid } from '../features/train-types-entity-grid/train-types-entity-grid';

export const AllTrainTypesPage = observer(() => {
  return (
    <AppPage perm="*" noWrapper>
      <TrainTypesEntityGrid />
    </AppPage>
  );
});
